import { render, staticRenderFns } from "./Free.vue?vue&type=template&id=8f71edac&"
import script from "./Free.vue?vue&type=script&lang=js&"
export * from "./Free.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports